import { container, inject, injectWithTransform, singleton } from "tsyringe";
import { ConsentProviderInterface } from "./consentProviders/consent-provider-interface";
import {
  countriesRequiringConsents,
  Geo,
  Logger,
  LoggerTransformer,
} from "@identity/utils";
import { OneTrust } from "./consentProviders/one-trust";
import { TcfApi } from "./consentProviders/tcf-api";
import { Consents } from "./types";
import { UspApi } from "./consentProviders/usp-api";
import { CookieBot } from "./consentProviders/cookie-bot";

@singleton()
export class ConsentProviderFactory {
  constructor(
    @injectWithTransform(Logger, LoggerTransformer, "OptInService")
    private logger: Logger,
    @inject(Geo) private geo: Geo,
  ) {}

  private consentProvider: ConsentProviderInterface;

  private createIABHandler(): Promise<Consents> {
    const location = this.geo.getCountryCode();
    if (location) {
      if (location === "us") {
        this.logger.info("__ucpapi installed");
        this.consentProvider = container.resolve(UspApi);
      } else if (countriesRequiringConsents.includes(location)) {
        this.logger.info("__tcfapi installed");
        this.consentProvider = container.resolve(TcfApi);
      }
    } else {
      this.logger.info("Privacy policy is not required");
      return Promise.resolve({
        gdprConsent: true,
        geoRequiresSignal: false,
        geoRequiresConsent: false,
        ccpaSignal: false,
      });
    }
    return this.consentProvider.consentGiven;
  }

  public get(fandom1TEnabled = false): Promise<Consents> {
    this.logger.info("Location: ", location);
    const constQuery: Promise<Consents>[] = [];

    // Install consent promise based on IAB API
    constQuery.push(this.createIABHandler());

    // Install CookieBot Cookie Manager for Fanatical
    if (CookieBot.enabled()) {
      constQuery.push(container.resolve(CookieBot).consentGiven);
      this.logger.info("CookieBot installed");
    }

    // Install OneTrust Consent Manager based on fandom1TEnabled flag
    if (fandom1TEnabled) {
      constQuery.push(container.resolve(OneTrust).consentGiven);
      this.logger.info("OneTrust installed");
    }

    return Promise.race(constQuery);
  }
}
